export default __webpack_public_path__ + "static/VAG_Art_45_Stifani_Finanz_GmbH-b17c17c901d1feb8e65cd248e510b5ca.pdf";